<div class="bp-modal-description">{{ "select_a_contact_description" | translate }}</div>
<div class="padded">
  <bp-input
    [hcArticle]="getSendTooltipExternalPath()"
    [error]="recipientAddressError | translate"
    [hcArticleTooltipTranslation]="'input_field_info_tooltip' | translate"
    id="recipient"
    (onKeyEnter)="selectRecipient()"
    (valueChange)="valueChange()"
    [type]="'search'"
    [(value)]="recipientAddress"
    [placeholder]="'placeholder_recipient_field' | translate"
  field="recipient"></bp-input>
</div>

<!-- DestinationTag -->
@if (isStellar()) {
  <div class="memo-select__flex-container padded">
    <bp-select class="memo-select" [options]="[dtType]" [(selectedValue)]="dtType.value" left></bp-select>
    <bp-input
      class="memo-select__full-width"
      [hcArticle]="getSendTooltipExternalPath()"
      [hcArticleTooltipTranslation]="'input_field_info_tooltip' | translate"
      [type]="'text'"
      [placeholder]="'stellar_memo_placeholder' | translate"
      (onKeyEnter)="selectRecipient()"
      [(value)]="destinationTag"
      (valueChange)="destinationTagChangeEmit()"
      [formGroupClass]="false"
      [error]="destinationTagError | translate">
    </bp-input>
  </div>
} @else {
  <div class="padded">
    @if (currentAsset?.supportsTag()) {
      <bp-input
        [hcArticle]="getSendTooltipExternalPath()"
        [hcArticleTooltipTranslation]="'input_field_info_tooltip' | translate"
        [maxChars]="128"
        (onKeyEnter)="selectRecipient()"
        [(value)]="destinationTag"
        (valueChange)="destinationTagChangeEmit()"
        [placeholder]="'placeholder_destination_tag' | translate: [getTagName()]"
        field="destination_tag"
      [error]="destinationTagError | translate"></bp-input>
    }
  </div>
}
